<template>
	<van-uploader 
		v-model="fileList"
		multiple
		:max-count="3"
		:after-read="afterRead"
		:before-read="asyncBeforeRead"
		:progress='true'
		:progress-interval="100"
		:disabled="disabled"
	>
		<van-button
	      type="primary"
	      :loading="loading"
	   >
	      {{ loading ? '上传中...' : '点击上传图片' }}
	   </van-button>
	</van-uploader>
</template>

<script>
import { screenshotUrl, uploadPicture } from "../plugins/api.js"	
import { Button } from 'vant';

export default {
	components: {
	    'van-button': Button
	  },
	props: {
	  upload_type: {
	    type: String,
	    default: ''
	  },
	  imgList: {
	    type: Array,
	    default () {
	      return []
	    }
	  }
	},
	data() {
		return {
			fileList: this.imgList,
			disabled: false,
			screenshotUrl_arr: [],
			loading: false,
		};
	},
	methods: {
		// 返回布尔值
		//上传时验证图片格式
		beforeRead (file) {
			const isType = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/git' || file.type === 'image/bmp'
			const isLt20M = file.size / 1024 / 1024 < 20
			if (!isType) {
				this.post_showMessage("上传图片仅支持 jpg、jpeg、png、git、bmp格式!")
			}
			if (!isLt20M) {
				this.post_showMessage("上传图片大小不能超过 20MB/张!")
			}
			return false
		},
		// 返回 Promise
		asyncBeforeRead(file, fileList) {
			this.loading = true; // Start loading
			// return new Promise((resolve, reject) => {
			// if (file.type !== 'image/jpeg') {
			// 	this.post_showMessage("上传图片仅支持 jpg、jpeg、png、git、bmp格式!")
			// 	reject();
			// } else {
			// 	resolve();
			// }
			// });
			console.log(file)
			console.log(fileList)
			const formData = new FormData();
			formData.append('file[]', file);
			      
			// 发起上传请求，使用你自定义的上传方法
			this.post_upload(formData, file);
		},
		afterRead(files, detail) {
			console.log(files, detail);
			// files.forEach(element => {
			//   // 模拟请求上传图片接口操作
			//   setTimeout(() => {
			//     element.status = null; // 上传成功后须将file对象的status属性置为null，否则遮罩不会消失。
			//   }, 2000);
			// });
		},
		// 请接口上传图片
		post_upload(fd, file, fileList){
			uploadPicture(fd).then(res => {
				console.log(res)
				this.uploading = false
				this.loading = false; // Start loading
					if(res.code == 0){
						if(res.data.urls && res.data.urls != ''){
							res.data.urls.forEach((item) => {
								this.screenshotUrl_arr.push(item)
								this.$emit('save_img_url', this.screenshotUrl_arr)
								this.fileList.push({ url: item })
							})
						}
					}else{
						this.post_showMessage(res.message)
						// this.Upload_failed_Remove(file.raw, fileList)
					}
			}, err => {
				this.uploading = false
				this.post_showMessage(err.message)
				// this.Upload_failed_Remove(file.raw, fileList)
			})
		},
		
		// 统一提示
		post_showMessage(text){
			this.$root.$emit('showMessage', { messageType: 'error', messageTime: 3000, globalMessage: text }); // 触发事件并传递消息
		},
  }
}
</script>

<style>
</style>